import { Scenario } from './scenario.model';
import { cloneDeep } from 'lodash-es';

export interface ScenarioComparisonInterface {
  scenarios: Scenario[];
  resultHistoryID: string | null;
}

export class ScenarioComparison {
  public scenarios: Scenario[];
  public resultHistoryID: string | null;

  constructor(param: ScenarioComparisonInterface = {
    scenarios: [],
    resultHistoryID: null
  }) {
    this.scenarios = [];

    if (param.scenarios && param.scenarios.length > 0) {
      for (const scenario of param.scenarios) {
        this.scenarios.push(new Scenario(scenario));
      }
    }

    this.resultHistoryID = param.resultHistoryID;
  }

  deepCopy() {
    return new ScenarioComparison(cloneDeep(this));
  }
}



